import styles from './Badge.module.css';

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface BadgeProps {
  children: string;
  variant?: BadgeVariant;
  className?: string;
}

/**
 * Status badge component for displaying labels with semantic color coding.
 *
 * Used for resource status (active/inactive), resource types, etc.
 */
export function Badge({ children, variant = 'neutral', className }: BadgeProps) {
  const classNames = [styles.badge, styles[variant], className ?? '']
    .filter(Boolean)
    .join(' ');

  return <span className={classNames}>{children}</span>;
}
